var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('md-progress-bar',{class:_vm.isInTransaction ? '' : 'md-accent',attrs:{"md-mode":"indeterminate"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }